/**
 * Generated by orval v6.26.0 🍺
 * Do not edit manually.
 * 爆版PC&开放平台
 * OpenAPI spec version: 1.0.0
 */
import { axiosInstance } from "../../axiosInstance";
export type PostBaobSettingPcGetShippingCompanyList200DataListItem = {
  /** 快递编号 */
  cniao?: string;
  /** id */
  cpid?: string;
  /** 快递公司名称 */
  shipping_company?: string;
  /** 快递100代号 */
  shipping_name?: string;
};

export type PostBaobSettingPcGetShippingCompanyList200Data = {
  list: PostBaobSettingPcGetShippingCompanyList200DataListItem[];
};

export type PostBaobSettingPcGetShippingCompanyList200 = {
  code: number;
  data: PostBaobSettingPcGetShippingCompanyList200Data;
  msg: string;
};

export type PostBaobSettingPcSupplyConfig200Data = {
  /** 4.64.0新增 */
  enable_unified_order: boolean;
  /** #7920新增 */
  in_supply_direct_delivery_white_list: boolean;
  is_activity_ai: number;
  /** #5146 */
  is_customer_advance_list: string;
  /** 4.58.0 */
  is_slow_compensation: string;
  /** #7920新增 */
  show_supply_direct_shipment_white_list: boolean;
  /** {0:禁用,1:启用,2:待禁用} */
  supply_status: string;
  /** 4.64.0新增 */
  unified_order_tab: boolean;
};

export type PostBaobSettingPcSupplyConfig200 = {
  code: string;
  data: PostBaobSettingPcSupplyConfig200Data;
  msg: string;
};

export type PostBaobSettingPcSupplyConfigBody = { [key: string]: any };

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary 爆版pc 用户公共配置
 */
export const postBaobSettingPcSupplyConfig = (
  postBaobSettingPcSupplyConfigBody: PostBaobSettingPcSupplyConfigBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobSettingPcSupplyConfig200>(
    {
      url: `/baob/SettingPc/supplyConfig`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postBaobSettingPcSupplyConfigBody,
    },
    options,
  );
};

/**
 * @summary 获取快递公司列表
 */
export const postBaobSettingPcGetShippingCompanyList = (
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobSettingPcGetShippingCompanyList200>(
    { url: `/baob/SettingPc/getShippingCompanyList`, method: "POST" },
    options,
  );
};

export type PostBaobSettingPcSupplyConfigResult = NonNullable<
  Awaited<ReturnType<typeof postBaobSettingPcSupplyConfig>>
>;
export type PostBaobSettingPcGetShippingCompanyListResult = NonNullable<
  Awaited<ReturnType<typeof postBaobSettingPcGetShippingCompanyList>>
>;
